import actiontypes from '../actiontypes'
import _ from 'common-tools/LodashHelper'
import IdHelper from 'common-tools/IdHelper'

let actions = {}

actions[actiontypes.Drawer.Show] = (state, action) => {
  let newState = _.merge({}, state)
  newState.drawers.push({
    key: IdHelper.uuId(),
    messageBusKey: action.payload.messageBusKey,
    drawerSize: action.payload.drawerSize,
    component: action.payload.component,
    props: action.payload.props
  })
  return newState
}

actions[actiontypes.Drawer.Hide] = (state, action) => {
  let newState = _.merge({}, state)
  if (action.payload.key === 'all') {
    newState.drawers = []
  } else {
    newState.drawers = _.reject(newState.drawers, { key: action.payload.key })
  }
  return newState
}

export default (state = {
  drawers: []
}, action) => {
  if (_.startsWith(action.type, actiontypes.Drawer.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
